/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export const Policy = {
  Required: "required",
  Optional: "optional",
} as const;
export type Policy = ClosedEnum<typeof Policy>;

export type AddPluginServerForm = {
  /**
   * Display name for the server. Defaults to the backing server name when omitted.
   */
  displayName?: string | undefined;
  /**
   * Speakeasy MCP server ID. Provide exactly one backend ID; a hosted MCP server's toolset_id and mcp_server_id may both be sent when equal.
   */
  mcpServerId?: string | undefined;
  /**
   * MCP gateway ID. Provide exactly one backend ID.
   */
  metaMcpServerId?: string | undefined;
  pluginId: string;
  policy?: Policy | undefined;
  sortOrder?: number | undefined;
  /**
   * Speakeasy toolset ID. Provide exactly one of toolset_id, mcp_server_id, or meta_mcp_server_id; a hosted MCP server's toolset_id and mcp_server_id may both be sent when equal.
   */
  toolsetId?: string | undefined;
};

/** @internal */
export const Policy$outboundSchema: z.ZodMiniEnum<typeof Policy> = z.enum(
  Policy,
);

/** @internal */
export type AddPluginServerForm$Outbound = {
  display_name?: string | undefined;
  mcp_server_id?: string | undefined;
  meta_mcp_server_id?: string | undefined;
  plugin_id: string;
  policy: string;
  sort_order: number;
  toolset_id?: string | undefined;
};

/** @internal */
export const AddPluginServerForm$outboundSchema: z.ZodMiniType<
  AddPluginServerForm$Outbound,
  AddPluginServerForm
> = z.pipe(
  z.object({
    displayName: z.optional(z.string()),
    mcpServerId: z.optional(z.string()),
    metaMcpServerId: z.optional(z.string()),
    pluginId: z.string(),
    policy: z._default(Policy$outboundSchema, "required"),
    sortOrder: z._default(z.int(), 0),
    toolsetId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      displayName: "display_name",
      mcpServerId: "mcp_server_id",
      metaMcpServerId: "meta_mcp_server_id",
      pluginId: "plugin_id",
      sortOrder: "sort_order",
      toolsetId: "toolset_id",
    });
  }),
);

export function addPluginServerFormToJSON(
  addPluginServerForm: AddPluginServerForm,
): string {
  return JSON.stringify(
    AddPluginServerForm$outboundSchema.parse(addPluginServerForm),
  );
}
